import axios from 'axios';
import {
	GET_SWITCH_LIST,
	ENDPOINT_URL,
	API_RESPONSE_SUCCESS_STATUS_CODE,
	AUTH_TOKEN_ERROR_STATUS_CODE,
	// AUTH_TOKEN_ERROR_STATUS_MSG,
	TOKEN_FAILED,
	GET_GLOBAL_VLAN_LIST,
	// POST_API_RESPONSE_SUCCESS_STATUS_CODE,
	API_RESPONSE_ERROR_STATUS_CODE_ALREADY_EXISTS,
	GET_PORTS_LIST_FOR_SWITCH,
	GET_ALL_VLAN_FOR_SWITCH,
	GET_SWITCH_DETAILS,
	DELETE_SWITCH,
	UPDATE_PORT_CONFIGURATION,
	GET_SWITCH_DASHBOARD_DETAILS,
	GET_SWITCH_ALARM_COUNT,
	GET_STATIC_MAC_API,
	GET_PORT_STATICS_API,
	// GET_SWITCH_INTERFACE_API,
	GET_SWITCH_DETAILS_SITE,
	GET_POE_UTILISATION,
	GET_CPU_UTILISATION,
	GET_SWITCH_TRAFFIC_PERFORMANCE,
	ADD_SWITCH_VLAN_API,
	MOVE_SWITCH_ENDPOINT,
	MOVE_MAC_API,
	GET_SWITCH_ALARMS_API,
	MAC_AGING_TIME_API,
	GET_SWITCH_PORT_CONFS,
	DELETE_STATIC_MAC_ADDRESS_API,
	REBOOT_SWITCH_API,
	SWITCH_PARTITION_API,
	GET_LLDP_REMOTE_DEVICES_API,
	GET_ALL_ACL_PORTS_SWITCH,
	GET_ALL_SWITCH_ACL_MAC,
	GET_ALL_SWITCH_ACL_IPV4,
	GET_ALL_SWITCH_ACL_IPV6,
	GET_LLDP_LOCAL_DEVICE_API,
	SWITCH_TEMPRATURE_API,
	ADD_STATIC_MAC_API,
	GET_SWITCH_DROPDOWN_LIST_API,
	API_SUCCESS_CODES
} from '../../constants/commonConstants';

import { logout } from '../userActions';
import {
	GLOBAL_VLAN_LIST_GET_FAIL,
	GLOBAL_VLAN_LIST_GET_SUCCESS,
	GLOBAL_VLAN_LIST_REQUEST_GET,
	SWITCH_LIST_GET_FAIL,
	SWITCH_LIST_GET_SUCCESS,
	SWITCH_LIST_REQUEST_GET,
	GLOBAL_VLAN_REQUEST_CREATE,
	GLOBAL_VLAN_CREATE_SUCCESS,
	GLOBAL_VLAN_CREATE_FAIL,
	SWITCH_REQUEST_ADD,
	SWITCH_ADD_FAIL,
	SWITCH_ADD_SUCCESS,
	SWITCH_BULK_ADD_SUCCESS_MSG,
	SWITCH_PORTS_GET,
	SWITCH_PORTS_GET_SUCCESS,
	SWITCH_PORTS_GET_FAIL,
	SWITCH_VLANS_GET,
	SWITCH_VLANS_GET_SUCCESS,
	SWITCH_VLANS_GET_FAIL,
	SWITCH_DETAILS_GET,
	SWITCH_DETAILS_GET_SUCCESS,
	SWITCH_DETAILS_GET_FAIL,
	SWITCH_REQUEST_DELETE,
	SWITCH_DELETE_FAIL,
	// SWITCH_DELETE_SUCCESS_MSG,
	SWITCH_DELETE_SUCCESS,
	// SWITCH_ADD_SUCCESS_MSG,
	GLOBAL_VLAN_REQUEST_UPDATE,
	GLOBAL_VLAN_UPDATE_SUCCESS,
	GLOBAL_VLAN_UPDATE_FAIL,
	GLOBAL_VLAN_REQUEST_DELETE,
	GLOBAL_VLAN_DELETE_SUCCESS,
	GLOBAL_VLAN_DELETE_FAIL,
	SWITCH_PORT_REQUEST_UPDATE,
	SWITCH_PORT_UPDATE_SUCCESS,
	SWITCH_PORT_UPDATE_FAIL,
	// SWITCH_PORT_UPDATE_SUCCESS_MSG,
	GET_SWITCH_ALARM_COUNT_SUCCESS,
	GET_SWITCH_ALARM_COUNT_FAIL,
	GET_STATIC_MAC_LIST,
	GET_STATIC_MAC_LIST_SUCCESS,
	GET_STATIC_MAC_LIST_FAILURE,
	GET_PORT_STATICS_LIST,
	GET_PORT_STATICS_LIST_SUCCESS,
	GET_PORT_STATICS_LIST_FAILURE,
	GET_POE_UTILISATION_LIST,
	GET_POE_UTILISATION_LIST_SUCCESS,
	GET_POE_UTILISATION_LIST_FAILURE,
	GET_CPU_UTILISATION_LIST,
	GET_CPU_UTILISATION_LIST_SUCCESS,
	GET_CPU_UTILISATION_LIST_FAILURE, 
	GET_SWITCH_TRAFFIC_LIST,
	GET_SWITCH_TRAFFIC_LIST_SUCCESS,
	GET_SWITCH_TRAFFIC_LIST_FAILURE,
	ADD_VLAN_SWITCH,
	ADD_VLAN_SWITCH_SUCCESS,
	ADD_VLAN_SWITCH_FAILURE,
	UPDATE_SWITCH_VLAN,
	UPDATE_SWITCH_VLAN_SUCCESS,
	UPDATE_SWITCH_VLAN_FAILURE,
	POST_MOVE_SWITCH,
	POST_MOVE_SWITCH_FAIL,
	POST_MOVE_SWITCH_SUCCESS,
	MOVE_DYNAMIC_MAC,
	MOVE_DYNAMIC_MAC_SUCCESS,
	MOVE_DYNAMIC_MAC_FAIL,
	GET_SWITCH_ALARMS_LIST,
	GET_SWITCH_ALARMS_LIST_SUCCESS,
	GET_SWITCH_ALARMS_LIST_FAILURE,
	MAC_AGING_TIME_FAILURE,
	MAC_AGING_TIME,
	MAC_AGING_TIME_SUCCESS,
	GET_MAC_AGING_TIME,
	GET_MAC_AGING_TIME_SUCCESS,
	GET_MAC_AGING_TIME_FAILURE,
	CLEAR_PORT_STATICS_LIST,
	// CLEAR_PORT_STATICS_SUCCESS_MESSAGE,
	CLEAR_PORT_STATICS_LIST_SUCCESS,
	CLEAR_PORT_STATICS_LIST_FAILURE,
	GET_PORT_CONFS_LIST,
	GET_PORT_CONFS_LIST_SUCCESS,
	GET_PORT_CONFS_LIST_FAILURE,
	DELETE_STATIC_MAC,
	DELETE_STATIC_MAC_SUCCESS,
	DELETE_STATIC_MAC_FAIL,
	REBOOT_SWITCH,
	REBOOT_SWITCH_SUCCESS,
	REBOOT_SWITCH_FAILURE,
	PARTITION_SWITCH,
	PARTITION_SWITCH_SUCCESS,
	PARTITION_SWITCH_FAILURE,
	GET_LLDP_REMOTE_DEVICES_LIST,
	GET_LLDP_REMOTE_DEVICES_LIST_SUCCESS,
	GET_LLDP_REMOTE_DEVICES_LIST_FAILURE,
	SWITCH_PORTS_ACL_GET,
	SWITCH_PORTS_ACL_GET_SUCCESS,
	SWITCH_PORTS_ACL_GET_FAIL,
	SWITCH_ACL_MAC_GET,
	SWITCH_ACL_MAC_GET_SUCCESS,
	SWITCH_ACL_MAC_GET_FAIL,
	SWITCH_ACL_IPV4_GET,
	SWITCH_ACL_IPV4_GET_SUCCESS,
	SWITCH_ACL_IPV4_GET_FAIL,
	SWITCH_ACL_IPV6_GET,
	SWITCH_ACL_IPV6_GET_SUCCESS,
	SWITCH_ACL_IPV6_GET_FAIL,
	// SWITCH_PORTS_ACL_PATCH,
	// SWITCH_PORTS_ACL_PATCH_SUCCESS,
	// SWITCH_PORTS_ACL_PATCH_FAIL
	SWITCH_TEMPRATURE_GRAPH_API_REQUEST,
    SWITCH_TEMPRATURE_GRAPH_API_SUCCESS,
    SWITCH_TEMPRATURE_GRAPH_API_FAIL

} from '../../constants/switchConstants';
import { decryptData, encryptData } from '../../utils/crypto';

export const getSwitchList =
	(limit = 4, offset = 0, siteId, search, status, model, firmware, viewMode) =>
		async (dispatch) => {
			try {
				dispatch({
					type: SWITCH_LIST_REQUEST_GET,
				});


				// let url;
				let url =
					ENDPOINT_URL +
					GET_SWITCH_LIST +
					'?limit=' +
					limit +
					'&offset=' +
					offset;
				if (siteId) {
					url =
						ENDPOINT_URL +
						GET_SWITCH_LIST +
						siteId +
						'/' +
						'?limit=' +
						limit +
						'&offset=' +
						offset;
				}
				if(!limit && !offset && !siteId && !search && !status && !firmware && model){
					url = ENDPOINT_URL + GET_SWITCH_LIST + '?model=' + model;
				}
				if(!limit && !offset && !siteId && !search && !status && !firmware && !model){
					url = ENDPOINT_URL + GET_SWITCH_LIST;
				}
				if (search) {
					url = url + '&search=' + search;
				}
				if(status===0 || status===1){
					url = url + '&status=' + status;
				}
				if(model){
					url = url + '&model=' + model;
				}
				if(firmware){
					url = url  + '&firmware=' + firmware;
				}
				if(viewMode){
					url = url  + '&view_mode=' + viewMode;
				}
				
				const config = {
					method: 'get',
					maxBodyLength: Infinity,
					url: url,
			};

				let { data } = await axios.request(config);
				const jsonString = decryptData(data);
				data = JSON.parse(jsonString);
				if (
					data?.status === AUTH_TOKEN_ERROR_STATUS_CODE
				) {
					//         throw {
					// 	type: SWITCH_LIST_GET_FAIL,
					// 	payload: TOKEN_FAILED,
					// };

					dispatch({
						type: SWITCH_LIST_GET_FAIL,
						payload: TOKEN_FAILED,
					});
					dispatch(logout());
				}
				if (
					data &&
					data.status &&
					API_SUCCESS_CODES.includes(data.status)
				) {
					dispatch({
						type: SWITCH_LIST_GET_SUCCESS,
						payload: {
							switches: data.results,
							totalCount: data.count},
					});
					return data;
				}
			} catch (error) {
				let message;
				if (error?.response?.data?.message || error.message) {
					message =
						error.response && error.response.data.message
							? error.response.data.message
							: error.message;
				}

				if (
					message === TOKEN_FAILED ||
					(error.type == SWITCH_LIST_GET_FAIL &&
						error.payload == TOKEN_FAILED)
				) {
					dispatch(logout());
				}
				// if (error.type && error.payload){
				//     dispatch(error);
				//     return;
				// }
				dispatch({
					type: SWITCH_LIST_GET_FAIL,
					payload: message,
				});
			}
		};

export const addSwitch = (payload) => async (dispatch) => {
	try {
		dispatch({
			type: SWITCH_REQUEST_ADD,
		});

		const jsonData = JSON.stringify(payload);
		const ciphertext = encryptData(jsonData);

		const url = ENDPOINT_URL + GET_SWITCH_LIST;

		const config = {
			method: 'post',
			maxBodyLength: Infinity,
			url: url,
			data: ciphertext,
		};

		let { data } = await axios.request(config);
		const jsonString = decryptData(data);
		data = JSON.parse(jsonString);
		if (
			data?.status === AUTH_TOKEN_ERROR_STATUS_CODE 
		) {
			dispatch({
				type: SWITCH_ADD_FAIL,
				payload: TOKEN_FAILED,
			});
			dispatch(logout());
		} else if (
			data?.status === API_RESPONSE_ERROR_STATUS_CODE_ALREADY_EXISTS &&
			data?.error
		) {
			dispatch({
				type: SWITCH_ADD_FAIL,
				payload: data.error,
			});
			return data
		} else if (
			data &&
			data.status &&
			API_SUCCESS_CODES.includes(data.status)
		) {
			dispatch({
				type: SWITCH_ADD_SUCCESS,
				payload: {
					data: data.data},
				msg: data?.msg,
			});
			return data
		} else if (
			data &&
			data.status &&
			data.status === API_RESPONSE_SUCCESS_STATUS_CODE &&
			data.msg === SWITCH_BULK_ADD_SUCCESS_MSG
		) {
			dispatch({
				type: SWITCH_ADD_SUCCESS,
				payload: {
					data: data.data},
			});
			return data
		} else if (data?.error) {
			dispatch({
				type: SWITCH_ADD_FAIL,
				payload: data.error,
			});
			return data;
		} else {
			dispatch({
				type: SWITCH_ADD_FAIL,
				payload: 'Unable to add switch',
			});
			return 'Unable to add switch'
		}
	} catch (error) {
		let message;
		if (error?.response?.data?.message || error.message) {
			message =
				error.response && error.response.data.message
					? error.response.data.message
					: error.message;
		}

		if (
			message === TOKEN_FAILED ||
			(error.type == SWITCH_ADD_FAIL && error.payload == TOKEN_FAILED)
		) {
			dispatch(logout());
		}
		dispatch({
			type: SWITCH_ADD_FAIL,
			payload: message,
		});
		return message

	}
};

export const deleteSwitch = (body, selectAll) => async (dispatch, getState) => {
	try {
		dispatch({
			type: SWITCH_REQUEST_DELETE,
		});
		const { } = getState();

		const jsonData = JSON.stringify(body);
		const ciphertext = encryptData(jsonData);

		let url = ENDPOINT_URL + DELETE_SWITCH;
		if (selectAll) {
			url += `?selectall=true`;
		}

		const config = {
			method: 'put',
			maxBodyLength: Infinity,
			url: url,
			data: ciphertext,
		};

		let { data } = await axios.request(config);
		const jsonString = decryptData(data);
		data = JSON.parse(jsonString);
		console.log('in get ap list...', data);
		if (
			data?.status === AUTH_TOKEN_ERROR_STATUS_CODE
		) {
			dispatch({
				type: SWITCH_DELETE_FAIL,
				payload: TOKEN_FAILED,
			});
			dispatch(logout());
		} else if (
			data?.status === API_RESPONSE_ERROR_STATUS_CODE_ALREADY_EXISTS &&
			data?.error
		) {
			dispatch({
				type: SWITCH_DELETE_FAIL,
				payload: data.error,
			});
		} else if (
			data &&
			data.status &&
			API_SUCCESS_CODES.includes(data.status)
		) {
			dispatch({
				type: SWITCH_DELETE_SUCCESS,
				payload: {
					data: data.data
				},
				msg: data?.msg,
				length: body.serial_no?.length
			});
			return data?.data
		} else {
			dispatch({
				type: SWITCH_DELETE_FAIL,
				payload: 'Unable to delete switch',
			});
		}
	} catch (error) {
		const message =
			error.response && error.response.data.message
				? error.response.data.message
				: error.message;
		console.log('error ', error);
		if (message === TOKEN_FAILED) {
			dispatch(logout());
		}
		dispatch({
			type: SWITCH_DELETE_FAIL,
			payload: message,
		});
	}
};

export const getGlobalVlanList =
	(limit = 50, offset = 0, siteId) =>
		async (dispatch) => {
			try {
				dispatch({
					type: GLOBAL_VLAN_LIST_REQUEST_GET,
				});

				let url;
 
                if (limit === null || offset === null) {
                    url = ENDPOINT_URL + GET_GLOBAL_VLAN_LIST;
                } else {
                    url =
                        ENDPOINT_URL +
                        GET_GLOBAL_VLAN_LIST +
                        '?limit=' +
                        limit +
                        '&offset=' +
                        offset;
                }
				const config = {
					method: 'get',
					maxBodyLength: Infinity,
					url: url,
			};

				let { data } = await axios.request(config);
				const jsonString = decryptData(data);
				data = JSON.parse(jsonString);
				dispatch({
					type: GLOBAL_VLAN_LIST_GET_SUCCESS,
					payload: {
						vlans: data?.results ?? [],
						totalCount: data?.count ?? 0},
				});
			} catch (error) {
				let message;
				if (error?.response?.data?.message || error.message) {
					message =
						error.response && error.response.data.message
							? error.response.data.message
							: error.message;
				}

				if (
					message === TOKEN_FAILED ||
					(error.type == GLOBAL_VLAN_LIST_GET_FAIL &&
						error.payload == TOKEN_FAILED)
				) {
					dispatch(logout());
				}
				// if (error.type && error.payload){
				//     dispatch(error);
				//     return;
				// }
				dispatch({
					type: GLOBAL_VLAN_LIST_GET_FAIL,
					payload: message,
				});
			}
		};

export const createGlobalVlan =
	({ vlanId, name, siteId }) =>
		async (dispatch, getState) => {
			try {
				dispatch({
					type: GLOBAL_VLAN_REQUEST_CREATE,
				});

				const jsonData = JSON.stringify({
					vlan_id: vlanId,
					name: name,
				});
				const ciphertext = encryptData(jsonData);

				const { } = getState();

				let url = ENDPOINT_URL + GET_GLOBAL_VLAN_LIST;
				if (siteId) {
					url = url + '&group=' + siteId;
				}

				const config = {
					method: 'post',
					maxBodyLength: Infinity,
					url: url,data: ciphertext,
				};

				let { data } = await axios.request(config);
				const jsonString = decryptData(data);
				data = JSON.parse(jsonString);
				if (
					data &&
					data.status &&
					data.status === API_RESPONSE_SUCCESS_STATUS_CODE
				) {
					dispatch({
						type: GLOBAL_VLAN_CREATE_SUCCESS,
					});
					return;
				}
				dispatch({
					type: GLOBAL_VLAN_CREATE_FAIL,
					payload:
						typeof data?.error === 'string'
						? data.error
						: data?.error?.vlan_id ||
							data?.error?.name ||
							data?.error?.detail ||
							'Unknown error',
					});
			} catch (error) {
				let message;
				if (error?.response?.data?.message || error.message) {
					message =
						error.response && error.response.data.message
							? error.response.data.message
							: error.message;
				}

				if (
					message === TOKEN_FAILED ||
					(error.type == GLOBAL_VLAN_CREATE_FAIL &&
						error.payload == TOKEN_FAILED)
				) {
					dispatch(logout());
				}
				// if (error.type && error.payload){
				//     dispatch(error);
				//     return;
				// }
				dispatch({
					type: GLOBAL_VLAN_CREATE_FAIL,
					payload: message,
				});
			}
		};

export const addSwitchVlan =
	({ switchId,vlanId, name, siteId }) =>
		async (dispatch, getState) => {
			try {
				dispatch({
					type: ADD_VLAN_SWITCH,
				});

				const vlanPayload = [{
					vlan_id: vlanId,
					name: name,
					// "is_applied_by_voice_vlan":true
				}];
				 
				const jsonData = JSON.stringify(vlanPayload)
		        const ciphertext = encryptData(jsonData);
			 
				const { } = getState();

				let url = ENDPOINT_URL + ADD_SWITCH_VLAN_API + switchId + '/';
				if (siteId) {
					url = url + '&group=' + siteId;
				}

				const config = {
					method: 'post',
					maxBodyLength: Infinity,
					url: url,data: ciphertext,
				};

				let { data } = await axios.request(config);
				const jsonString = decryptData(data);
				data = JSON.parse(jsonString);
				if(API_SUCCESS_CODES.includes(data?.status)){
					dispatch({
						type: ADD_VLAN_SWITCH_SUCCESS,
						payload: data
					});
				} else{
					dispatch({
						type: ADD_VLAN_SWITCH_FAILURE,
						payload:
							data?.error?.vlan_id ??
							data?.error?.name ??
							'Unknown error',
					});
				}
				return data;
			} catch (error) {
				let message;
				if (error?.response?.data?.message || error.message) {
					message =
						error.response && error.response.data.message
							? error.response.data.message
							: error.message;
				}

				if (
					message === TOKEN_FAILED ||
					(error.type == ADD_VLAN_SWITCH_FAILURE &&
						error.payload == TOKEN_FAILED)
				) {
					dispatch(logout());
				}
				// if (error.type && error.payload){
				//     dispatch(error);
				//     return;
				// }
				dispatch({
					type: ADD_VLAN_SWITCH_FAILURE,
					payload: message,
				});
				return message;
			}
		};
export const getPortsForSwitch =
	({ limit = 60, offset = 0, switchId, siteId }) =>
		async (dispatch, getState) => {
			try {
				dispatch({
					type: SWITCH_PORTS_GET,
				});

				const { } = getState();

				let url =
					ENDPOINT_URL +
					GET_PORTS_LIST_FOR_SWITCH +
					`${switchId}/` +
					'?limit=' +
					limit +
					'&offset=' +
					offset;
				if (siteId) {
					url = url + '&group=' + siteId;
				}

				const config = {
					method: 'get',
					maxBodyLength: Infinity,
					url: url,
			};

				let { data: responseBody } = await axios.request(config);
				const jsonString = decryptData(responseBody);
				responseBody = JSON.parse(jsonString);
				if (responseBody?.data == null) throw Error('invalid response');
				if(API_SUCCESS_CODES.includes(responseBody?.status)){
					dispatch({
						type: SWITCH_PORTS_GET_SUCCESS,
						payload: responseBody?.data,
					});

				} 
				dispatch({
					type: SWITCH_PORTS_GET_SUCCESS,
					payload: responseBody?.data,
				});
			} catch (error) {
				let message;
				if (error?.response?.data?.message || error.message) {
					message =
						error.response && error.response.data.message
							? error.response.data.message
							: error.message;
				}

				dispatch({
					type: SWITCH_PORTS_GET_FAIL,
					payload: message,
				});
			}
		};

export const getVlansForSwitch =
	({ limit, offset, switchId, siteId }) =>
		async (dispatch) => {
			try {
				dispatch({
					type: SWITCH_VLANS_GET,
				});

				let url =
					ENDPOINT_URL +
					GET_ALL_VLAN_FOR_SWITCH +
					`${switchId}/` +
					'?limit=' +
					limit +
					'&offset=' +
					offset;
				if (siteId) {
					url = url + '&group=' + siteId;
				}
				if (switchId) {
					url = ENDPOINT_URL +
					GET_ALL_VLAN_FOR_SWITCH +
					`${switchId}/`;
				}

				const config = {
					method: 'get',
					maxBodyLength: Infinity,
					url: url,
			};

				let { data: responseBody } = await axios.request(config);
				const jsonString = decryptData(responseBody);
				responseBody = JSON.parse(jsonString);
				if (responseBody.data == null) {
					throw Error('invalid response');
				}
				dispatch({
					type: SWITCH_VLANS_GET_SUCCESS,
					payload: responseBody.data,
				});
			} catch (error) {
				let message;
				if (error?.response?.data?.message || error.message) {
					message =
						error.response && error.response.data.message
							? error.response.data.message
							: error.message;
				}

				dispatch({
					type: SWITCH_VLANS_GET_FAIL,
					payload: message,
				});
			}
		};

export const getAclPortsForSwitch = 
	({ limit = 50, offset = 0, switchId, siteId }) => 
		async (dispatch) => {
		try {
			dispatch({ type: SWITCH_PORTS_ACL_GET });


			let url =
					ENDPOINT_URL +
					GET_ALL_ACL_PORTS_SWITCH +
					`${switchId}/` +
					'?limit=' +
					limit +
					'&offset=' +
					offset;
			if (siteId) {
			url += `&group=${siteId}`;
			}

			if (switchId) {
				url = ENDPOINT_URL +
				GET_ALL_ACL_PORTS_SWITCH +
				`${switchId}/`;
			}

			const config = {
			method: "get",
			url
		};

			const { data: responseBody } = await axios.request(config);
			const jsonString = decryptData(responseBody);
			const responseData = JSON.parse(jsonString);

			if (!responseData?.data) throw new Error("Invalid response");

			dispatch({
			type: SWITCH_PORTS_ACL_GET_SUCCESS,
			payload: responseData.data,
			});
		} catch (error) {
			let message;
				if (error?.response?.data?.message || error.message) {
					message =
						error.response && error.response.data.message
							? error.response.data.message
							: error.message;
				}
				if (message === TOKEN_FAILED) {
					dispatch(logout());
				}

			dispatch({ type: SWITCH_PORTS_ACL_GET_FAIL, payload: message });
		}
};

export const patchAclPortsForSwitch = async ({ switchId, body, getState }) => {
    try {
        const { } = getState();

        const url =
            ENDPOINT_URL +
            GET_ALL_ACL_PORTS_SWITCH +
            `${switchId}/`;

        const config = {
            method: "patch",
            url,data: body,
        };

        const { data: responseBody } = await axios.request(config);
        const jsonString = decryptData(responseBody);
        const responseData = JSON.parse(jsonString);

        if (!responseData?.data) throw new Error("Invalid response");

        return { success: true, data: responseData.data };
    } catch (error) {
        let message;
        if (error?.response?.data?.message || error.message) {
            message =
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message;
        }

        return { success: false, message };
    }
};


export const getAclMacForSwitch = 
	({ limit = 50, offset = 0, siteId }) => 
		async (dispatch) => {
		try {
			dispatch({ type: SWITCH_ACL_MAC_GET });


			let url =
					ENDPOINT_URL +
					GET_ALL_SWITCH_ACL_MAC +
					'?limit=' +
					limit +
					'&offset=' +
					offset;
			if (siteId) {
			url += `&group=${siteId}`;
			}

			const config = {
			method: "get",
			url
	};

			const { data: responseBody } = await axios.request(config);
			const jsonString = decryptData(responseBody);
			const responseData = JSON.parse(jsonString);

			if (!responseData?.data) throw new Error("Invalid response");

			dispatch({
			type: SWITCH_ACL_MAC_GET_SUCCESS,
			payload: responseData.data,
			});
		} catch (error) {
			let message;
				if (error?.response?.data?.message || error.message) {
					message =
						error.response && error.response.data.message
							? error.response.data.message
							: error.message;
				}

			dispatch({ type: SWITCH_ACL_MAC_GET_FAIL, payload: message });
		}
};

export const getAclIpv4ForSwitch = 
	({ limit = 50, offset = 0, siteId }) => 
		async (dispatch, getState) => {
		try {
			dispatch({ type: SWITCH_ACL_IPV4_GET });


			let url =
					ENDPOINT_URL +
					GET_ALL_SWITCH_ACL_IPV4 +
					'?limit=' +
					limit +
					'&offset=' +
					offset;
			if (siteId) {
			url += `&group=${siteId}`;
			}

			const config = {
			method: "get",
			url
		};

			const { data: responseBody } = await axios.request(config);
			const jsonString = decryptData(responseBody);
			const responseData = JSON.parse(jsonString);

			if (!responseData?.data) throw new Error("Invalid response");

			dispatch({
			type: SWITCH_ACL_IPV4_GET_SUCCESS,
			payload: responseData.data,
			});
		} catch (error) {
			let message;
				if (error?.response?.data?.message || error.message) {
					message =
						error.response && error.response.data.message
							? error.response.data.message
							: error.message;
				}

			dispatch({ type: SWITCH_ACL_IPV4_GET_FAIL, payload: message });
		}
};

export const getAclIpv6ForSwitch = 
	({ limit = 50, offset = 0, siteId }) => 
		async (dispatch) => {
		try {
			dispatch({ type: SWITCH_ACL_IPV6_GET });


			let url =
					ENDPOINT_URL +
					GET_ALL_SWITCH_ACL_IPV6 +
					'?limit=' +
					limit +
					'&offset=' +
					offset;
			if (siteId) {
			url += `&group=${siteId}`;
			}

			const config = {
			method: "get",
			url
		};

			const { data: responseBody } = await axios.request(config);
			const jsonString = decryptData(responseBody);
			const responseData = JSON.parse(jsonString);

			if (!responseData?.data) throw new Error("Invalid response");

			dispatch({
			type: SWITCH_ACL_IPV6_GET_SUCCESS,
			payload: responseData.data,
			});
		} catch (error) {
			let message;
				if (error?.response?.data?.message || error.message) {
					message =
						error.response && error.response.data.message
							? error.response.data.message
							: error.message;
				}

			dispatch({ type: SWITCH_ACL_IPV6_GET_FAIL, payload: message });
		}
};

export const getSwitchDetails =
	({ switchId, siteId }) =>
		async (dispatch) => {
			try {
				dispatch({
					type: SWITCH_DETAILS_GET,
				});


				let url = ENDPOINT_URL + GET_SWITCH_DETAILS + `${switchId}/`;
				if (siteId) {
					url = url + '&group=' + siteId;
				}

				const config = {
					method: 'get',
					maxBodyLength: Infinity,
					url: url,
			};

				let { data } = await axios.request(config);
				const jsonString = decryptData(data);
				data = JSON.parse(jsonString);
				if (
					data?.status === AUTH_TOKEN_ERROR_STATUS_CODE
				) {
					

					dispatch({
						type: SWITCH_DETAILS_GET_FAIL,
						payload: TOKEN_FAILED,
					});
					dispatch(logout());
				}
				dispatch({
					type: SWITCH_DETAILS_GET_SUCCESS,
					payload: data.data,
				});
			} catch (error) {
				let message;
				if (error?.response?.data?.message || error.message) {
					message =
						error.response && error.response.data.message
							? error.response.data.message
							: error.message;
				}

				dispatch({
					type: SWITCH_DETAILS_GET_FAIL,
					payload: message,
				});
			}
		};

export const updateGlobalVlan =
	({ vlans, siteId }) =>
		async (dispatch, getState) => {
			try {
				dispatch({
					type: GLOBAL_VLAN_REQUEST_UPDATE,
				});

				const { } = getState();

				const jsonData = JSON.stringify(vlans);
				const ciphertext = encryptData(jsonData);

				let url = ENDPOINT_URL + GET_GLOBAL_VLAN_LIST;
				if (siteId) {
					url = url + '&group=' + siteId;
				}

				const config = {
					method: 'patch',
					maxBodyLength: Infinity,
					url: url,data: ciphertext,
				};

				let { data } = await axios.request(config);
				const jsonString = decryptData(data);
				data = JSON.parse(jsonString);
				if (
					data &&
					data.status &&
					data.status === API_RESPONSE_SUCCESS_STATUS_CODE
				) {
					dispatch({
						type: GLOBAL_VLAN_UPDATE_SUCCESS,
					});
					return data;
				}
				dispatch({
					type: GLOBAL_VLAN_UPDATE_FAIL,
					payload:
						data?.error?.vlan_id ??
						data?.error?.name ??
						'Unknown error',
				});
				return data?.error?.vlan_id ??
				data?.error?.name ??
				'Unknown error';
			} catch (error) {
				let message;
				if (error?.response?.data?.message || error.message) {
					message =
						error.response && error.response.data.message
							? error.response.data.message
							: error.message;
				}

				if (
					message === TOKEN_FAILED ||
					(error.type == GLOBAL_VLAN_UPDATE_FAIL &&
						error.payload == TOKEN_FAILED)
				) {
					dispatch(logout());
				}
				// if (error.type && error.payload){
				//     dispatch(error);
				//     return;
				// }
				dispatch({
					type: GLOBAL_VLAN_UPDATE_FAIL,
					payload: message,
				});
				return message;
			}
		};
		export const updateVlan =
		(vlans, switchId ) =>
			async (dispatch, getState) => {
				try {
					dispatch({
						type: UPDATE_SWITCH_VLAN,
					});
	
					const { } = getState();
	
					const jsonData = JSON.stringify(vlans);
					const ciphertext = encryptData(jsonData);
	
					const url = ENDPOINT_URL + GET_ALL_VLAN_FOR_SWITCH + switchId + '/' ;
					
	
					const config = {
						method: 'patch',
						maxBodyLength: Infinity,
						url: url,data: ciphertext,
					};
	
					let { data } = await axios.request(config);
					const jsonString = decryptData(data);
					data = JSON.parse(jsonString);
					if(API_SUCCESS_CODES.includes(data?.status)){
						dispatch({
							type: UPDATE_SWITCH_VLAN_SUCCESS,
						});
						return data;
					} else{
						dispatch({
							type: UPDATE_SWITCH_VLAN_FAILURE,
							payload:
								data?.error?.vlan_id ??
								data?.error?.name ??
								'Unknown error',
						});
					}
				} catch (error) {
					let message;
					if (error?.response?.data?.message || error.message) {
						message =
							error.response && error.response.data.message
								? error.response.data.message
								: error.message;
					}
	
					if (
						message === TOKEN_FAILED ||
						(error.type == GLOBAL_VLAN_UPDATE_FAIL &&
							error.payload == TOKEN_FAILED)
					) {
						dispatch(logout());
					}
					// if (error.type && error.payload){
					//     dispatch(error);
					//     return;
					// }
					dispatch({
						type: UPDATE_SWITCH_VLAN_FAILURE,
						payload: message,
					});
				}
			};
export const deleteGlobalVlan =
	({ vlans, siteId }) =>
		async (dispatch, getState) => {
			try {
				dispatch({
					type: GLOBAL_VLAN_REQUEST_DELETE,
				});

				const jsonData = JSON.stringify(vlans);
				const ciphertext = encryptData(jsonData);

				const { } = getState();

				let url = ENDPOINT_URL + GET_GLOBAL_VLAN_LIST;
				if (siteId) {
					url = url + '&group=' + siteId;
				}

				const config = {
					method: 'put',
					maxBodyLength: Infinity,
					url: url,data: ciphertext,
				};

				let { data } = await axios.request(config);
				const jsonString = decryptData(data);
				data = JSON.parse(jsonString);
				if (
					data &&
					data.status &&
					data.status === API_RESPONSE_SUCCESS_STATUS_CODE
				) {
					dispatch({
						type: GLOBAL_VLAN_DELETE_SUCCESS,
					});
					return;
				}
				dispatch({
					type: GLOBAL_VLAN_DELETE_FAIL,
					payload:
						data?.error ??
						data?.error?.vlan_id ??
						data?.error?.name ??
						'Unknown error',
				});
			} catch (error) {
				let message;
				if (error?.response?.data?.message || error.message) {
					message =
						error.response && error.response.data.message
							? error.response.data.message
							: error.message;
				}

				if (
					message === TOKEN_FAILED ||
					(error.type == GLOBAL_VLAN_DELETE_FAIL &&
						error.payload == TOKEN_FAILED)
				) {
					dispatch(logout());
				}
				// if (error.type && error.payload){
				//     dispatch(error);
				//     return;
				// }
				dispatch({
					type: GLOBAL_VLAN_DELETE_FAIL,
					payload: message,
				});
			}
		};

export const updatePorts =
	(payload, switchId) => async (dispatch, getState) => {
		try {
			dispatch({
				type: SWITCH_PORT_REQUEST_UPDATE,
			});

			const { } = getState();

			const url =
				ENDPOINT_URL + UPDATE_PORT_CONFIGURATION + switchId + '/';
			// const jsonData = JSON.stringify(payload);
			// const ciphertext = encryptData(jsonData);           
			const config = {
				method: 'patch',
				maxBodyLength: Infinity,
				url: url,data: payload,
			};

			let { data } = await axios.request(config);
			const jsonString = decryptData(data);
			data = JSON.parse(jsonString);
			console.log("portData", data)

			if (
				data &&
				data?.status && API_SUCCESS_CODES.includes(data?.status)
			
			) {
				dispatch({
					type: SWITCH_PORT_UPDATE_SUCCESS,
				});
				return 'success';
			}
			dispatch({
				type: SWITCH_PORT_UPDATE_FAIL,
				payload: data?.error ?? 'Unknown error',
			});
		} catch (error) {
			let message;
			if (error?.response?.data?.message || error.message) {
				message =
					error.response && error.response.data.message
						? error.response.data.message
						: error.message;
			}

			if (
				message === TOKEN_FAILED ||
				(error.type == SWITCH_PORT_UPDATE_FAIL &&
					error.payload == TOKEN_FAILED)
			) {
				dispatch(logout());
			}
			dispatch({
				type: SWITCH_PORT_UPDATE_FAIL,
				payload: message,
			});
		}
	};

export const getSwitchDashboardDetails =
	({ switchId, siteId }) =>
	async (dispatch, getState) => {
		console.log('switch id here', switchId);
		try {
			// dispatch({
			// 	type: SWITCH_DETAILS_GET,
			// });

			const { } = getState();

			let url =
				ENDPOINT_URL + GET_SWITCH_DASHBOARD_DETAILS + `${switchId}/`;
			if (siteId) {
				url = url + '&group=' + siteId;
			}

			const config = {
				method: 'get',
				maxBodyLength: Infinity,
				url: url,
			};

			let { data } = await axios.request(config);
			const jsonString = decryptData(data);
			data = JSON.parse(jsonString);
			console.log('data in dashboard api', data);
			// dispatch({
			// 	type: SWITCH_DETAILS_GET_SUCCESS,
			// 	payload: data.data,
			// });
			return data?.data
		} catch (error) {
			let message;
			if (error?.response?.data?.message || error.message) {
				message =
					error.response && error.response.data.message
						? error.response.data.message
						: error.message;
			}

			return message

			// dispatch({
			// 	type: SWITCH_DETAILS_GET_FAIL,
			// 	payload: message,
			// });
		}
	};

export const getSwichData =
	({ switchId, siteId }) =>
	async (dispatch, getState) => {
		console.log('switch id here', switchId);
		try {
		
			const { } = getState();

			let url =
				ENDPOINT_URL + GET_SWITCH_DASHBOARD_DETAILS + `${switchId}/`;
			if (siteId) {
				url = url + '&group=' + siteId;
			}

			const config = {
				method: 'get',
				maxBodyLength: Infinity,
				url: url,
			};

			let { data } = await axios.request(config);
			const jsonString = decryptData(data);
			data = JSON.parse(jsonString);
			console.log('data in dashboard api', data);
			// dispatch({
			// 	type: SWITCH_DETAILS_GET_SUCCESS,
			// 	payload: data.data,
			// });
			return data?.data
		} catch (error) {
			let message;
			if (error?.response?.data?.message || error.message) {
				message =
					error.response && error.response.data.message
						? error.response.data.message
						: error.message;
			}

			return message

			// dispatch({
			// 	type: SWITCH_DETAILS_GET_FAIL,
			// 	payload: message,
			// });
		}
	};

export const getPoeUtilizatinData =
({switchId,  filter, startTime, endTime} ) =>
async (dispatch, getState) => {
	console.log('switch id here', switchId);
	try {
		dispatch({
			type: GET_POE_UTILISATION_LIST,
		});

		const { } = getState();

		let url =
			ENDPOINT_URL + GET_POE_UTILISATION + `${switchId}/?filter=${filter}`;
		
			// Add startTime and endTime if they are provided
		if (startTime && endTime) {
			url += `&start_time=${startTime}&end_time=${endTime}`;
		}

		const config = {
			method: 'get',
			maxBodyLength: Infinity,
			url: url,
			};

		let { data } = await axios.request(config);
		const jsonString = decryptData(data);
		data = JSON.parse(jsonString);
		console.log('data in dashboard api', data);
		if (
			data &&
			data.status &&
			data.status === AUTH_TOKEN_ERROR_STATUS_CODE 
		) {
			dispatch(logout());
			return []
		}
		else if(data && data.data){
			dispatch({
				type: GET_POE_UTILISATION_LIST_SUCCESS,
				payload: data.data,
			});
			return data?.data
		}else {
			dispatch({
				type: GET_POE_UTILISATION_LIST_SUCCESS,
				payload: data.data,
			});
			return []
		}
	} catch (error) {
		let message;
		if (error?.response?.data?.message || error.message) {
			message =
				error.response && error.response.data.message
					? error.response.data.message
					: error.message;
		}


		dispatch({
			type: GET_POE_UTILISATION_LIST_FAILURE,
			payload: message,
		});
		return message

	}
};

export const getSwitchPortConfs =
(switchId ) =>
async (dispatch, getState) => {
	console.log('switch id here', switchId);
	try {
		dispatch({
			type: GET_PORT_CONFS_LIST,
		});

		const { } = getState();

		const url =
			ENDPOINT_URL + GET_SWITCH_PORT_CONFS + `${switchId}/`;
		

		const config = {
			method: 'get',
			maxBodyLength: Infinity,
			url: url,
			};

		let { data } = await axios.request(config);
		const jsonString = decryptData(data);
		data = JSON.parse(jsonString);

		if(data.data){
			dispatch({
				type: GET_PORT_CONFS_LIST_SUCCESS,
				payload: data.data,
			});
			return data.data
		}else{
			dispatch({
				type: GET_PORT_CONFS_LIST_FAILURE,
				payload: 'Unable to fetch data',
			});
			return []
		}
	} catch (error) {
		let message;
		if (error?.response?.data?.message || error.message) {
			message =
				error.response && error.response.data.message
					? error.response.data.message
					: error.message;
		}


		dispatch({
			type: GET_PORT_CONFS_LIST_FAILURE,
			payload: message,
		});
		return message

	}
};

export const getCpuUtilizatinData =
({switchId,  filter, startTime, endTime}) =>
async (dispatch, getState) => {
	try {
		dispatch({
			type: GET_CPU_UTILISATION_LIST,
		});

		const { } = getState();

		const startTimeInSeconds = Math.floor(startTime / 1000);
		const endTimeInSeconds = Math.floor(endTime / 1000);
		
		let url = ENDPOINT_URL + GET_CPU_UTILISATION + `${switchId}/` + '?filter=' + filter; ;
		
		// Add startTime and endTime if they are provided
		if (startTime && endTime) {
			url += `&start_time=${startTimeInSeconds}&end_time=${endTimeInSeconds}`;
		}

		const config = {
			method: 'get',
			maxBodyLength: Infinity,
			url: url,
			};

		let { data } = await axios.request(config);
		const jsonString = decryptData(data);
		data = JSON.parse(jsonString);
		console.log('getSwitchTrafficPerformanceData', data);
		if(data){
			dispatch({
				type: GET_CPU_UTILISATION_LIST_SUCCESS,
				payload: data?.cpu_mem_util,
			});
			return data?.cpu_mem_util
		}
		if (
			data &&
			data.status &&
			data.status === AUTH_TOKEN_ERROR_STATUS_CODE 
		) {
			dispatch(logout());
		}
	} catch (error) {
		let message;
		if (error?.response?.data?.message || error.message) {
			message =
				error.response && error.response.data.message
					? error.response.data.message
					: error.message;
		}
		dispatch({
			type: GET_CPU_UTILISATION_LIST_FAILURE,
			payload: message,
		});
		return message
	}
};

export const getSwitchTrafficPerformanceData = 
  ({serialNumber, filter = '4hours', startTime, endTime}) => 
  async (dispatch, getState) => {
    console.log('Switch traffic performance test', serialNumber, filter);
    try {
        dispatch({
            type: GET_SWITCH_TRAFFIC_LIST,
        });

        const { } = getState();
		
		const startTimeInSeconds = Math.floor(startTime / 1000);
		const endTimeInSeconds = Math.floor(endTime / 1000);
        let url = ENDPOINT_URL + GET_SWITCH_TRAFFIC_PERFORMANCE + `?serial_no=${serialNumber}&filter=${filter}`;
		
		// Add startTime and endTime if they are provided
		if (startTime && endTime) {
			url += `&start_time=${startTimeInSeconds}&end_time=${endTimeInSeconds}`;
		}
        const config = {
            method: 'get',
            maxBodyLength: Infinity,
            url: url,
			}

        let { data } = await axios.request(config);
        const jsonString = decryptData(data);
        data = JSON.parse(jsonString);
		if (
			data &&
			data.status &&
			data.status === AUTH_TOKEN_ERROR_STATUS_CODE
		) {
			dispatch(logout());
			return
		}
		if(data){
			dispatch({
				type: GET_SWITCH_TRAFFIC_LIST_SUCCESS,
				payload: data?.traffic_data,
			});
			return data?.traffic_data;
		}else {
			dispatch({
				type: GET_SWITCH_TRAFFIC_LIST_SUCCESS,
				payload: [],
			});
			return [];
		}
    } catch (error) {
        let message;
        if (error?.response?.data?.message || error.message) {
            message =
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message;
        }

        dispatch({
            type: GET_SWITCH_TRAFFIC_LIST_FAILURE,
            payload: message,
        });
        return message;
    }
};

export const getSwitchAlarmDetails = (body) => async (dispatch, getState) => {
	try {
		const { } = getState();

		const url = ENDPOINT_URL + GET_SWITCH_ALARM_COUNT;
		const jsonData = JSON.stringify(body);
		const ciphertext = encryptData(jsonData);
		const config = {
			method: 'post',
			maxBodyLength: Infinity,
			url: url,data: ciphertext,
		};

		let { data } = await axios.request(config);
		const jsonString = decryptData(data);
		data = JSON.parse(jsonString);
		console.log('data in dashboard api alarms', data);
		dispatch({
			type: GET_SWITCH_ALARM_COUNT_SUCCESS,
			payload: data,
		});
	} catch (error) {
		let message;
		if (error?.response?.data?.message || error.message) {
			message =
				error.response && error.response.data.message
					? error.response.data.message
					: error.message;
		}

		dispatch({
			type: GET_SWITCH_ALARM_COUNT_FAIL,
			payload: message,
		});
	}
};


// export const getSwitchInterfaceDetails =
// 	({ switchId }) =>
// 	async (dispatch, getState) => {
// 		try {
// 			dispatch({
// 				type: SWITCH_DETAILS_GET,
// 			});

// 			const {
// 				userLogin: { userInfo },
// 			} = getState();

// 			const url =
// 				ENDPOINT_URL + GET_SWITCH_INTERFACE_API + `${switchId}/`;

// 			const config = {
// 				method: 'get',
// 				maxBodyLength: Infinity,
// 				url: url,
// now handled globally
// 				},
// 			};

// 			let { data } = await axios.request(config);
// 			const jsonString = decryptData(data);
// 			data = JSON.parse(jsonString);
// 			console.log('data in dashboard interface', data);
// 			dispatch({
// 				type: SWITCH_DETAILS_GET_SUCCESS,
// 				payload: data.data,
// 			});
// 		} catch (error) {
// 			let message;
// 			if (error?.response?.data?.message || error.message) {
// 				message =
// 					error.response && error.response.data.message
// 						? error.response.data.message
// 						: error.message;
// 			}

// 			dispatch({
// 				type: SWITCH_DETAILS_GET_FAIL,
// 				payload: message,
// 			});
// 		}
// 	};

export const getStaticMacList =
	(switchId, search) =>
		async (dispatch, getState) => {
			try {
				dispatch({
					type: GET_STATIC_MAC_LIST,
				});

				const { } = getState();

				let url =
					ENDPOINT_URL +
					GET_STATIC_MAC_API +
					switchId +
					'/';
				if (search) {
					url = url + '?search=' + search;
				}

				const config = {
					method: 'get',
					maxBodyLength: Infinity,
					url: url,
			};

				let { data } = await axios.request(config);
				const jsonString = decryptData(data);
				data = JSON.parse(jsonString);
				if (data?.data == null) {
					dispatch({
						type: GET_STATIC_MAC_LIST_FAILURE,
						payload: 'Invalid Response',
					});
				}

				if(API_SUCCESS_CODES.includes(data?.status) || (data?.data !== null && data?.data !== undefined)){
				dispatch({
					type: GET_STATIC_MAC_LIST_SUCCESS,
					payload: data?.data,
				});
				return data?.data
			}
			} catch (error) {
				let message;
				if (error?.response?.data?.message || error.message) {
					message =
						error.response && error.response.data.message
							? error.response.data.message
							: error.message;
				}

				dispatch({
					type: GET_STATIC_MAC_LIST_FAILURE,
					payload: message,
				});
				return message
			}
		};

export const getSwitchAlarmsList =
(limit = 50, offset = 0,switchId, search, filters,selectedSite) =>
	async (dispatch, getState) => {
		try {
			dispatch({
				type: GET_SWITCH_ALARMS_LIST,
			});

			const { } = getState();

		let url =
			ENDPOINT_URL +
			GET_SWITCH_ALARMS_API +
			'0/' +
			'?limit=' +
				limit +
				'&offset=' +
				offset;

			if (search) {
				url = url + '&search=' + search;
			}

			// let method;
			// if (filters && Object.keys(filters).length > 0) {
			// 	method = 'post';
			// } else {
			// 	method = 'get';
			// }
			let postData = {};
			if(switchId === 'null'){
				postData = {};
				if(selectedSite){
					postData = {"site_id": selectedSite}
					if(filters && Object.keys(filters).length > 0){
						postData = {
							...filters,
							"site_id": selectedSite
						};
					}
				}
				else if(filters && Object.keys(filters).length > 0){
					postData = {
						...filters,
					};
				}
			} else {
				postData = {
					device: switchId
				};
				if(filters && Object.keys(filters).length > 0){
					postData = {
						...filters,
						device: switchId
					};
				}
			}
				
			console.log("postData",postData);
			const jsonData = JSON.stringify(postData);
			const ciphertext = encryptData(jsonData);
			
			const config = {
				method: 'post',
				maxBodyLength: Infinity,
				url: url,data: ciphertext
			};

			// if (method === 'post') {
			// 	const postData = {
			// 		...filters,
			// 		device: switchId
			// 	}
			// 	const jsonData = JSON.stringify(postData);
			// 	const ciphertext = encryptData(jsonData);
			// 	config['data'] = ciphertext;
			// }
			let { data } = await axios.request(config);
			const jsonString = decryptData(data);
			data = JSON.parse(jsonString);
			if(data && data.results){
				dispatch({
					type: GET_SWITCH_ALARMS_LIST_SUCCESS,
					payload: {
						results: data,
						totalCount: data.count
					},
				})
			}else{
				dispatch({
					type: GET_SWITCH_ALARMS_LIST_FAILURE,
					payload: 'Unable to fetch alarms list',
				});
			}
		} catch (error) {
			let message;
			if (error?.response?.data?.message || error.message) {
				message =
					error.response && error.response.data.message
						? error.response.data.message
						: error.message;
			}

			dispatch({
				type: GET_SWITCH_ALARMS_LIST_FAILURE,
				payload: message,
			});
		}
	};

export const getPortStaticsList =
	(switchId) =>
		async ( dispatch, getState ) => {
			try {
				dispatch({
					type: GET_PORT_STATICS_LIST,
				});

				const { } = getState();

				const url =
					ENDPOINT_URL +
					GET_PORT_STATICS_API +
					switchId +
					'/';
				const config = {
					method: 'get',
					maxBodyLength: Infinity,
					url: url,
				};

				let { data } = await axios.request(config);
				const jsonString = decryptData(data);
				data = JSON.parse(jsonString);

				if (data?.data == null) {
					throw Error('invalid response');
				}
				if(API_SUCCESS_CODES.includes(data?.status)){
				dispatch({
					type: GET_PORT_STATICS_LIST_SUCCESS,
					payload: data?.data,
				});
				return data?.data
			}
			} catch (error) {
				let message;
				if (error?.response?.data?.message || error.message) {
					message =
						error.response && error.response.data.message
							? error.response.data.message
							: error.message;
				}

				dispatch({
					type: GET_PORT_STATICS_LIST_FAILURE,
					payload: message,
				});
			}
		};

export const getLldpRemoteDevicesList =
(switchId) =>
	async ( dispatch, getState ) => {
		try {
			dispatch({
				type: GET_LLDP_REMOTE_DEVICES_LIST,
			});

			const { } = getState();

			const url =
				ENDPOINT_URL +
				GET_LLDP_REMOTE_DEVICES_API +
				switchId +
				'/';
			const config = {
				method: 'get',
				maxBodyLength: Infinity,
				url: url,
			};

			let { data } = await axios.request(config);
			const jsonString = decryptData(data);
			data = JSON.parse(jsonString);

			if(data && API_SUCCESS_CODES.includes(data?.status)){
				dispatch({
					type: GET_LLDP_REMOTE_DEVICES_LIST_SUCCESS,
					payload: data?.data,
				});
			}else{
				dispatch({
					type: GET_LLDP_REMOTE_DEVICES_LIST_FAILURE,
					payload: 'Error fetching LLDP Devices',
				});
			}
		} catch (error) {
			let message;
			if (error?.response?.data?.message || error.message) {
				message =
					error.response && error.response.data.message
						? error.response.data.message
						: error.message;
			}

			dispatch({
				type: GET_LLDP_REMOTE_DEVICES_LIST_FAILURE,
				payload: message,
			});
		}
	};

export const getLldpLocalDeviceData =
(switchId) =>
	async ( dispatch, getState ) => {
		try {
			const { } = getState();

			const url =
				ENDPOINT_URL +
				GET_LLDP_LOCAL_DEVICE_API +
				switchId +
				'/';
			const config = {
				method: 'get',
				maxBodyLength: Infinity,
				url: url,
			};

			let { data } = await axios.request(config);
			const jsonString = decryptData(data);
			data = JSON.parse(jsonString);

			if(data && data.status == API_RESPONSE_SUCCESS_STATUS_CODE){
				return data
			}else{
				return {}
			}
		} catch (error) {
			const message =
			error.response && error.response.data.message
				? error.response.data.message
				: error.message;
			if (message === TOKEN_FAILED) {
				dispatch(logout());
			}
			return {}
		}
	};

export const getFilterDeviceData =
	() =>
		async ( dispatch, getState ) => {
			try {
				const { } = getState();
	
				const url =
					ENDPOINT_URL +
					GET_SWITCH_DROPDOWN_LIST_API 
					
	
				const config = {
					method: 'get',
					maxBodyLength: Infinity,
					url: url,
			};
	
				let { data } = await axios.request(config);
				const jsonString = decryptData(data);
				data = JSON.parse(jsonString);
	
				if(data && data.status == API_RESPONSE_SUCCESS_STATUS_CODE){
					return data?.data;
				}else{
					return {}
				}
			} catch (error) {
				const message =
				error.response && error.response.data.message
					? error.response.data.message
					: error.message;
				if (message === TOKEN_FAILED) {
					dispatch(logout());
				}
				return {}
			}
		};
	

export const clearPortStatisticsList =
(payload, switchId) => async (dispatch, getState) => {
    try {
        // Dispatch request action
        dispatch({
            type: CLEAR_PORT_STATICS_LIST,
        });

        const { } = getState();

		const jsonData = JSON.stringify(payload);
		const ciphertext = encryptData(jsonData);
		
        // Configure request

        const config = {
            method: 'put',
            url: ENDPOINT_URL + GET_PORT_STATICS_API + switchId + '/',
			data: ciphertext,
        };

        // Send request and get response
		let { data } = await axios.request(config);
		const jsonString = decryptData(data);
		data = JSON.parse(jsonString);

		if(data && API_SUCCESS_CODES.includes(data?.status) ){
			dispatch({
				type: CLEAR_PORT_STATICS_LIST_SUCCESS,
			});
			return data?.status
		}else{
			dispatch({
				type: CLEAR_PORT_STATICS_LIST_FAILURE,
				payload: 'Failed to clear port statistics',
			});
			return 'failure'
		}
    } catch (error) {
        // Handle error
        console.error('Failed to update user profile:', error);
        dispatch({
            type: CLEAR_PORT_STATICS_LIST_FAILURE,
            payload: error.message || 'Failed to clear port statistics',
        });
        throw error;
    }
};

export const getSwitchDetailsSite = ({ siteId }) =>
	async (dispatch, getState) => {
		try {
			dispatch({
				type: SWITCH_DETAILS_GET,
			});

			const { } = getState();

			const url =
				ENDPOINT_URL +
				GET_SWITCH_DETAILS_SITE + siteId + '/';
			

			const config = {
				method: 'get',
				maxBodyLength: Infinity,
				url: url,
			};

			let { data } = await axios.request(config);
			const jsonString = decryptData(data);
			data = JSON.parse(jsonString);
			dispatch({
				type: SWITCH_DETAILS_GET_SUCCESS,
				payload: data.data,
			});

		} catch (error) {
			let message;
			if (error?.response?.data?.message || error.message) {
				message = error.response && error.response.data.message
					? error.response.data.message
					: error.message;
			}

			dispatch({
				type: SWITCH_DETAILS_GET_FAIL,
				payload: message,
			});
		}
	};

export const moveSwitch = (payload) => async (dispatch, getState) => {
	try {
		dispatch({
			type: POST_MOVE_SWITCH,
		});

		const { } = getState();

		const url = ENDPOINT_URL + MOVE_SWITCH_ENDPOINT;
		const jsonData = JSON.stringify(payload);
		const ciphertext = encryptData(jsonData);
		const config = {
			method: 'post',
			maxBodyLength: Infinity,
			url: url,data: ciphertext,
		};
		let { data } = await axios.request(config);
		const jsonString = decryptData(data);
		data = JSON.parse(jsonString);
		if (
			data &&
			data.status &&
		    API_SUCCESS_CODES.includes(data?.status)
		) {
			dispatch({
				type: POST_MOVE_SWITCH_SUCCESS,
				payload: data.msg,
			});
		}
		if (
			data &&
			data.status &&
			data.status === AUTH_TOKEN_ERROR_STATUS_CODE 
		) {
			dispatch({
				type: POST_MOVE_SWITCH_FAIL,
				payload: TOKEN_FAILED,
			});
			dispatch(logout());
		}
		return data;
	} catch (error) {
		const message =
			error.response && error.response.data.message
				? error.response.data.message
				: error.message;
		console.log('error ', error);
		if (message === TOKEN_FAILED) {
			dispatch(logout());
		}
		dispatch({
			type: POST_MOVE_SWITCH_FAIL,
			payload: message,
		});
	}
};

export const moveMacAddress = (payload) => async (dispatch, getState) => {
	try {
		dispatch({
			type: MOVE_DYNAMIC_MAC,
		});

		const { } = getState();

		const url = ENDPOINT_URL + MOVE_MAC_API;
		const jsonData = JSON.stringify(payload);
		const ciphertext = encryptData(jsonData);
		const config = {
			method: 'post',
			maxBodyLength: Infinity,
			url: url,data: ciphertext,
		};
		let { data } = await axios.request(config);
		const jsonString = decryptData(data);
		data = JSON.parse(jsonString);
		if (
			data &&
			data.status && API_SUCCESS_CODES.includes(data?.status)
		) {
			dispatch({
				type: MOVE_DYNAMIC_MAC_SUCCESS,
				payload: data,
			});
			return data
		}
		if (
			data &&
			data.status &&
			data.status === AUTH_TOKEN_ERROR_STATUS_CODE
		) {
			dispatch({
				type: MOVE_DYNAMIC_MAC_FAIL,
				payload: TOKEN_FAILED,
			});
			dispatch(logout());
		}
	} catch (error) {
		const message =
			error.response && error.response.data.message
				? error.response.data.message
				: error.message;
		console.log('error ', error);
		if (message === TOKEN_FAILED) {
			dispatch(logout());
		}
		dispatch({
			type: MOVE_DYNAMIC_MAC_FAIL,
			payload: message,
		});
		return message
	}
};

export const deleteMacAddress = (payload) => async (dispatch, getState) => {
	try {
		dispatch({
			type: DELETE_STATIC_MAC,
		});

		const { } = getState();

		const url = ENDPOINT_URL + DELETE_STATIC_MAC_ADDRESS_API;
		const jsonData = JSON.stringify(payload);
		const ciphertext = encryptData(jsonData);
		const config = {
			method: 'post',
			maxBodyLength: Infinity,
			url: url,data: ciphertext,
		};
		let { data } = await axios.request(config);
		const jsonString = decryptData(data);
		data = JSON.parse(jsonString);
		if (
			data &&
			data.status &&
			data.status === API_RESPONSE_SUCCESS_STATUS_CODE
		) {
			dispatch({
				type: DELETE_STATIC_MAC_SUCCESS,
				payload: data,
			});
			return data
		}
		if (
			data &&
			data.status &&
			data.status === AUTH_TOKEN_ERROR_STATUS_CODE
		) {
			dispatch({
				type: DELETE_STATIC_MAC_FAIL,
				payload: TOKEN_FAILED,
			});
			dispatch(logout());
		}
	} catch (error) {
		const message =
			error.response && error.response.data.message
				? error.response.data.message
				: error.message;
		console.log('error ', error);
		if (message === TOKEN_FAILED) {
			dispatch(logout());
		}
		dispatch({
			type: DELETE_STATIC_MAC_FAIL,
			payload: message,
		});
		return message
	}
};

export const updateMacAgingeTime =
	(payload) => async (dispatch, getState) => {
		try {
			dispatch({
				type: MAC_AGING_TIME,
			});

			const { } = getState();

			const url =
				ENDPOINT_URL + MAC_AGING_TIME_API
			const jsonData = JSON.stringify(payload);
			const ciphertext = encryptData(jsonData);

			const config = {
				method: 'patch',
				maxBodyLength: Infinity,
				url: url,data: ciphertext,
			};

			let { data } = await axios.request(config);
			const jsonString = decryptData(data);
			data = JSON.parse(jsonString);

			if (
				data &&
				data.status 
			) {
				dispatch({
					type: MAC_AGING_TIME_SUCCESS,
				});
				return data
			}
			dispatch({
				type: MAC_AGING_TIME_FAILURE,
				payload: data?.error ?? 'Unknown error',
			});
		} catch (error) {
			let message;
			if (error?.response?.data?.message || error.message) {
				message =
					error.response && error.response.data.message
						? error.response.data.message
						: error.message;
			}

			if (
				message === TOKEN_FAILED ||
				(error.type == MAC_AGING_TIME_FAILURE &&
					error.payload == TOKEN_FAILED)
			) {
				dispatch(logout());
			}
			dispatch({
				type: MAC_AGING_TIME_FAILURE,
				payload: message,
			});
		}
	};

	export const getMacAgeTime =
	( switchId ) =>
		async (dispatch, getState) => {
			try {
				dispatch({
					type:GET_MAC_AGING_TIME,
				});

				const { } = getState();

				const url = ENDPOINT_URL + MAC_AGING_TIME_API + '?serial_no=' + switchId;
		
                console.log("url11",url)
				const config = {
					method: 'get',
					maxBodyLength: Infinity,
					url: url,
			};

				let { data } = await axios.request(config);
				const jsonString = decryptData(data);
				data = JSON.parse(jsonString);
				dispatch({
					type: GET_MAC_AGING_TIME_SUCCESS,
					payload: data,
				});
				return data
			} catch (error) {
				let message;
				if (error?.response?.data?.message || error.message) {
					message =
						error.response && error.response.data.message
							? error.response.data.message
							: error.message;
				}

				dispatch({
					type: GET_MAC_AGING_TIME_FAILURE,
					payload: message,
				});
			}
		};

		export const rebootSwitch = (payload) => async (dispatch, getState) => {
			try {
				console.log(payload, 'reboot switch api');
				dispatch({
					type: REBOOT_SWITCH,
				});
		
				const { } = getState();
				const jsonData = JSON.stringify(payload);
				const ciphertext = encryptData(jsonData);
		
				const url = ENDPOINT_URL + REBOOT_SWITCH_API;
		
				const config = {
					method: 'post',
					maxBodyLength: Infinity,
					url: url,data: ciphertext,
				};
		
				let { data } = await axios.request(config);
				const jsonString = decryptData(data);
				data = JSON.parse(jsonString);
				if (
					data?.status === AUTH_TOKEN_ERROR_STATUS_CODE 
				) {
					dispatch({
						type: SWITCH_ADD_FAIL,
						payload: TOKEN_FAILED,
					});
					dispatch(logout());
				} else if (
					data?.status === API_RESPONSE_ERROR_STATUS_CODE_ALREADY_EXISTS &&
					data?.error
				) {
					dispatch({
						type: REBOOT_SWITCH_FAILURE ,
						payload: data.error,
					});
					return data
				} else if (
					data &&
					data.status &&
					API_SUCCESS_CODES.includes(data?.status)
				) {
					dispatch({
						type: REBOOT_SWITCH_SUCCESS,
						payload: {
							data: data},
					});
					return data
				} else {
					dispatch({
						type: REBOOT_SWITCH_FAILURE,
						payload: 'Unable to reboot switch',
					});
					return 'Unable to reboot switch'
				}
			} catch (error) {
				let message;
				if (error?.response?.data?.message || error.message) {
					message =
						error.response && error.response.data.message
							? error.response.data.message
							: error.message;
				}
		
				if (
					message === TOKEN_FAILED ||
					(error.type == SWITCH_ADD_FAIL && error.payload == TOKEN_FAILED)
				) {
					dispatch(logout());
				}
				dispatch({
					type: SWITCH_ADD_FAIL,
					payload: message,
				});
				return message
		
			}
		};

		export const updateSwitchPartition = (payload,switchId) => async (dispatch, getState) => {
			try {
				console.log(payload, 'partition switch');
				dispatch({
					type: PARTITION_SWITCH,
				});
		
				const { } = getState();
				const jsonData = JSON.stringify(payload);
				const ciphertext = encryptData(jsonData);
		
				const url = ENDPOINT_URL + SWITCH_PARTITION_API + switchId + '/';
		
				const config = {
					method: 'post',
					maxBodyLength: Infinity,
					url: url,data: ciphertext,
				};
		
				let { data } = await axios.request(config);
				const jsonString = decryptData(data);
				data = JSON.parse(jsonString);
				if (
					data?.status === AUTH_TOKEN_ERROR_STATUS_CODE
				) {
					dispatch({
						type: SWITCH_ADD_FAIL,
						payload: TOKEN_FAILED,
					});
					dispatch(logout());
				} else if (
					data &&
					data.status &&
					API_SUCCESS_CODES.includes(data?.status)
				) {
					dispatch({
						type: PARTITION_SWITCH_SUCCESS,
						payload: {
							data: data},
					});
					return data
				} else {
					dispatch({
						type: PARTITION_SWITCH_FAILURE,
						payload: 'Someting went wrong',
					});
					return 'Someting went wrong'
				}
			} catch (error) {
				let message;
				if (error?.response?.data?.message || error.message) {
					message =
						error.response && error.response.data.message
							? error.response.data.message
							: error.message;
				}
		
				if (
					message === TOKEN_FAILED ||
					(error.type == SWITCH_ADD_FAIL && error.payload == TOKEN_FAILED)
				) {
					dispatch(logout());
				}
				dispatch({
					type: SWITCH_ADD_FAIL,
					payload: message,
				});
				return message
		
			}
		};

/**
 * Api to fetch the switch temperature graph data for site dashboard
 * @param {*} param0 
 * @return {function} - Asynchronous function that dispatches actions based on the API response.
*/
export const getSwitchTemratureGraphData = 
({switchId, filter = '4hours', startTime, endTime}) => 
async (dispatch, getState) => {
  console.log('Switch temprature test', switchId, filter);
  try {
	dispatch({
		type: SWITCH_TEMPRATURE_GRAPH_API_REQUEST,
	});

	const { } = getState();
	  
	const startTimeInSeconds = Math.floor(startTime / 1000);
	const endTimeInSeconds = Math.floor(endTime / 1000);

	let url =
		ENDPOINT_URL + SWITCH_TEMPRATURE_API + switchId + '/?filter=' + filter;

	// Add startTime and endTime if they are provided
	if (startTime && endTime) {
		url += `&start_time=${startTimeInSeconds}&end_time=${endTimeInSeconds}`;
	}
	const config = {
		method: 'get',
		maxBodyLength: Infinity,
		url: url,
	};

	let { data } = await axios.request(config);
	const jsonString = decryptData(data);
	data = JSON.parse(jsonString);
	console.log('getSwitchTemratureGraphData', data);
	if (
	  data &&
	  data.status &&
	  data.status === AUTH_TOKEN_ERROR_STATUS_CODE 
	) {
	  dispatch(logout());
	  return
	}
	else if(data && data.temperature && Array.isArray(data.temperature)){
	  dispatch({
		type: SWITCH_TEMPRATURE_GRAPH_API_SUCCESS,
		payload: data?.temperature,
	  });
	  return data;
	}else {
	  dispatch({
		type: SWITCH_TEMPRATURE_GRAPH_API_FAIL,
		payload: [],
	  });
	}
  } catch (error) {
	let message;
	if (error?.response?.data?.message || error.message) {
	  message =
		error.response && error.response.data.message
		  ? error.response.data.message
		  : error.message;
	}
	dispatch({
	  type: SWITCH_TEMPRATURE_GRAPH_API_FAIL,
	  payload: message,
	});
	return message;
  }
};

export const addStaticMac = (payload) => async (dispatch, getState) => {
	try {	
		const { } = getState();

		const jsonData = JSON.stringify(payload);
		const ciphertext = encryptData(jsonData);

		const url = ENDPOINT_URL +  ADD_STATIC_MAC_API;

		const config = {
			method: 'post',
			maxBodyLength: Infinity,
			url: url,data: ciphertext,
		};

		let { data } = await axios.request(config);
		const jsonString = decryptData(data);
		data = JSON.parse(jsonString);
		if (
			data?.status === AUTH_TOKEN_ERROR_STATUS_CODE
		) {
			dispatch(logout());
		} else if (
			data &&
			data.status &&
			API_SUCCESS_CODES.includes(data?.status)
		) {
			return data
		} else {
			
			return 'Someting went wrong'
		}
	} catch (error) {
		let message;
		if (error?.response?.data?.message || error.message) {
			message =
				error.response && error.response.data.message
					? error.response.data.message
					: error.message;
		}

		if (
			message === TOKEN_FAILED ||
			(error.type == SWITCH_ADD_FAIL && error.payload == TOKEN_FAILED)
		) {
			dispatch(logout());
		}
		return message

	}
};

export const editStaticMac =
	(payload) =>
		async (dispatch, getState) => {
			try {
				

				const { } = getState();

				const jsonData = JSON.stringify(payload);
				const ciphertext = encryptData(jsonData);

				const url = ENDPOINT_URL + ADD_STATIC_MAC_API;
				

				const config = {
					method: 'patch',
					maxBodyLength: Infinity,
					url: url,data: ciphertext,
				};

				let { data } = await axios.request(config);
				const jsonString = decryptData(data);
				data = JSON.parse(jsonString);

				if (
					data &&
					data.status &&
					API_SUCCESS_CODES.includes(data?.status)
				) {
					return data;
				}
				
			} catch (error) {
				let message;
				if (error?.response?.data?.message || error.message) {
					message =
						error.response && error.response.data.message
							? error.response.data.message
							: error.message;
				    return message

				}

				if (
					message === TOKEN_FAILED ||
					(error.type == GLOBAL_VLAN_UPDATE_FAIL &&
						error.payload == TOKEN_FAILED)
				) {
					dispatch(logout());
				}
				// if (error.type && error.payload){
				//     dispatch(error);
				//     return;
				// }
			}
		};